module.exports = __webpack_public_path__ + "static/media/1.16_preview.6efb5b24.png";